<!-- Manual de orientaçao para contratação de plano de saúde -->
<section>
  <app-manual-orientacao-proposta
    [dadosOperadoraDM]="dadosOperadoraDM"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [tipoProduto]="tipoProduto"></app-manual-orientacao-proposta>
</section>
<!-- Formulário do Beneficiário -->
<section>
  <app-formulario-beneficiario-proposta
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [dadosOperadoraDM]="dadosOperadoraDM"
    [tipoProduto]="tipoProduto"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [heMedSenior]="heMedSenior"
    [listaBeneficiariosFormulario]="listaBeneficiariosFormulario"></app-formulario-beneficiario-proposta>
</section>
<!-- Dados Bancários  -->
<section>
  <app-formulario-dados-bancarios-proposta
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [dadosOperadoraDM]="dadosOperadoraDM"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [nomeTitular]="nomeTitular"
    [tipoPlano]="tipoPlano"
    [tipoRegistroProduto]="tipoRegistroProduto"
    [ansProduto]="ansProduto"
    [acomadacaoPlano]="acomadacaoPlano"
    [dataAssinaturaDadosBancarios]="dataAssinaturaDadosBancarios"
    [horaAssinaturaDadosBancarios]="horaAssinaturaDadosBancarios"
    [totalPlano]="totalPlano"
    [totalPlanoComTaxa]="totalPlanoComTaxa"
    [beneficiarios]="beneficiarios"
    [cpfTitular]="cpfTitular"
    [heMedSenior]="heMedSenior"
    [valorRecebidoPeloBeneficiario]="valorRecebidoPeloBeneficiario"></app-formulario-dados-bancarios-proposta>

  <app-assinatura-documento
    [nomeTitular]="nomeTitular"
    [dataAssinatura]="dataAssinaturaDadosBancarios"
    [horaAssinatura]="horaAssinaturaDadosBancarios"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
</section>
<!-- Proposta adesão UDEMO -->
<section *ngIf="!heMedSenior">
  <div class="documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

    <h3
      class="titulo text-center bold-preto-700 mb-1"
      style="padding: 0.5rem; background: black; color: #fff; border-radius: 10px">
      PROPOSTA DE ADESÃO UNIMED FESP
    </h3>
    <p class="mb-1">
      Pelo presente instrumento, solicito a minha adesão, e dos dependentes por mim relacionados, como BENEFICIÁRIO do
      CONTRATO DE PLANO DE SAÚDE firmado em 01/10/2009 entre a operadora de planos de saúde UNIMED – FEDERAÇÃO DAS
      UNIMEDS DO ESTADO DE SÃO PAULO, registrada na Agência Nacional de Saúde Suplementar – ANS sob o número 31.999-6 e
      no CNPJ/MF sob nº 43.643.136/0001-66, com endereço à Rua José Getúlio, 78/90 – Aclimação – São Paulo – SP – CEP:
      01509-000, denominada CONTRATADA, e a UDEMO - Sindicato de Especialistas de Educação do Magistério Oficial do
      Estado de São Paulo, com endereço à Av. Ipiranga, 318 - Bloco B 7º Andar - Centro - São Paulo-SP - CEP 01046-925,
      inscrita no CNPJ/MF sob nº 45.136.074/0001-98, denominada CONTRATANTE.
    </p>
    <ul>
      <li>
        <p class="m-2">
          1. A CONTRATANTE compromete-se a administrar e intermediar o contrato médico hospitalar com a CONTRATADA, nas
          melhores condições possíveis em prol do BENEFICIÁRIO, consoantes às obrigações contratuais pactuadas entre a
          CONTRATANTE e CONTRATADA, inclusive para administrar junto a CONTRATADA, a movimentação cadastral do plano de
          saúde do BENEFICIÁRIO especialmente no que se diz respeito aos procedimentos relativos às inscrições,
          inclusões, exclusões, cancelamentos e transferências.
        </p>
      </li>
      <li>
        <p class="m-2">
          2. O BENEFICIÁRIO fica ciente de que a administração financeira do plano de saúde pela CONTRATANTE será
          efetuada através do sistema de pré-pagamento, ou seja, toda e qualquer movimentação cadastral do plano de
          saúde terá que ser solicitada no mês anterior ao da sua efetiva vigência, ficando desde já ciente de que o
          período estabelecido entre a CONTRATANTE e CONTRATADA para a movimentação será até o 5º dia útil de cada mês
          (ou dia útil anterior) a serem realizadas na Géia ou Sede da {{ entidadeProposta }}, exceto em casos de
          cancelamento, onde o contrato deverá obedecer às regras inseridas na Resolução Normativa editada pela Agência
          Nacional de Saúde Suplementar, RN nº 412/2016. Sendo a solicitação valida quando realizada diretamente na
          Unimed Fesp ou na sede do sindicato UDEMO.
        </p>
      </li>
      <li>
        <p class="m-2">
          3. Os grupos de adesão deverão constituir-se regularmente até o 5º dia útil de cada mês (ou dia útil
          anterior), na Géia ou na Sede da
          {{ entidadeProposta }}. Imediatamente expirado esse prazo, a CONTRATANTE é obrigada a comunicar a CONTRATADA
          às inclusões de novos BENEFICIÁRIOS, que terão atendimento garantido conforme a carência do contrato a partir
          do 1º (primeiro) dia do mês subsequente a inscrição.
        </p>
      </li>
      <li>
        <p class="m-2">
          4. As inclusões e/ou alterações efetuadas até o 5º dia útil de cada mês (ou dia útil anterior), na Géia ou na
          Sede da
          {{ entidadeProposta }}, serão efetuadas para vigorar no mês subsequente. Nos casos de exclusões de
          beneficiários dependentes ou o cancelamento da sua adesão, o BENEFICIÁRIO TITULAR, compromete-se a comunicar,
          através dos canais de comunicação disponibilizados pela OPERADORA E ENTIDADE ADERENTE, em cumprimento à
          Resolução Normativa editada pela Agência Nacional de Saúde Suplementar, RN nº 561/2022, sua intenção, opção
          esta que surtirá efeito de forma imediata e terá caráter irrevogável e irretratável.
        </p>
      </li>
      <li>
        <p class="m-2">
          5. A CONTRATANTE é responsável junto à CONTRATADA pelo recolhimento da mensalidade do convênio todo 5º
          (quinto) dia útil de cada mês, através de débito em conta corrente do BENEFICIÁRIO, por intermédio da rede de
          agências do SANTANDER e BANCO DO BRASIL ou através de desconto em folha de pagamento. Essas mensalidades serão
          repassadas pela CONTRATANTE à CONTRATADA via regime pré-pagamento, nos termos estabelecidos no Contrato
          Padrão.
        </p>
      </li>
      <li>
        <p class="m-2">
          6. Declara o BENEFICIÁRIO TITULAR possuir completo conhecimento de que os valores das mensalidades serão
          reajustados conforme a sinistralidade apurada, bem como na ocasião de mudança de faixa etária, na forma
          prevista pelo CONTRATO DE PLANO DE SAÚDE celebrado entre ESTIPULANTE e a CONTRATADA e também prevista no
          MANUAL DE ORIENTAÇÃO PARA CONTRATAÇÃO DE PLANO DE SAÚDE - MPS.
        </p>
      </li>
      <li>
        <p class="m-2">
          7. O BENEFICIÁRIO expressa ter pleno conhecimento de que a confecção e a expedição no tempo hábil das
          carteirinhas do convênio são de inteira responsabilidade da CONTRATADA, bem como quaisquer omissões ou erros
          registrados na confecção, ficando, no entanto, a CONTRATANTE, fica obrigada a intervir junto a CONTRATADA
          sempre que necessário para resguardar os direitos dos BENEFICIÁRIOS neste particular.
        </p>
      </li>
      <li>
        <p class="m-2">
          8.Fica estabelecido que a CONTRATANTE, é mera intermediária na contratação da cobertura de custos de
          assistência médico-hospitalar, expressa na cópia do contrato que o BENEFICIÁRIO recebe ao aderir ao convênio,
          ficando estipulado ainda, que os serviços de assistência médica são de exclusiva responsabilidade dos
          profissionais e instituições a serviço da CONTRATADA, sendo certo que quaisquer falhas e/ou deficiências de
          serviços, assistência ou atendimento médico hospitalar, registradas na urgência da opção do plano de saúde, no
          qual estiver incluído o BENEFICIÁRIO ou os dependentes, são de exclusiva responsabilidade dos profissionais e
          instituições a serviço da CONTRATADA.
        </p>
      </li>
      <li>
        <p class="m-2">
          9.O BENEFICIÁRIO compromete-se a atender todas as obrigações estatutárias de sócio da
          {{ entidadeProposta }}, mantendo em dia sua contribuição associativa e fornecendo ainda todos os dados,
          declarações e opções necessárias a implantação das obrigações acometidas pelo presente instrumento à
          CONTRATANTE. Obriga-se o BENEFICIÁRIO ainda, a comunicar, por escrito, mudanças de endereços ou alterações de
          quaisquer dados fornecidos anteriormente SOB PENA DE EXCLUSÃO DO CONVÊNIO, sem prejuízo de reembolso das
          despesas decorrentes do uso indevido do convênio.
        </p>
      </li>
      <li>
        <p class="m-2">
          10. O BENEFICIÁRIO compromete-se a efetuar o pagamento mensal dos custos do convênio ANTECIPADAMENTE, a partir
          do mês em que passe a usufruir os serviços prestados pela CONTRATADA, nas bases e condições, inclusive as
          relacionadas com o reajustamento do preço estabelecidas no Contrato Padrão. O referido pagamento será efetuado
          no dia em que a categoria do magistério Estadual, receber seus vencimentos mês após mês, através do débito
          automático em sua conta corrente por intermédio da rede de agências do banco SANTANDER e BANCO DO BRASIL ou
          através de desconto em folha de pagamento, servindo este instrumento como autorização expressa do BENEFICIÁRIO
          para que seja efetuado o referido débito até sua exclusão do convênio, ou término do contrato, em favor da
          CONTRATANTE.
        </p>
      </li>
      <li>
        <p class="m-2">
          11. O BENEFICIÁRIO compromete-se a efetuar o pagamento mensal dos custos do convênio ANTECIPADAMENTE, a partir
          do mês em que passe a usufruir os serviços prestados pela CONTRATADA, nas bases e condições, inclusive as
          relacionadas com o reajustamento do preço estabelecidas no Contrato Padrão. O referido pagamento será efetuado
          no dia em que a categoria do magistério Estadual, receber seus vencimentos mês após mês, através do débito
          automático em sua conta corrente por intermédio da rede de agências do banco SANTANDER e BANCO DO BRASIL ou
          através de desconto em folha de pagamento, servindo este instrumento como autorização expressa do BENEFICIÁRIO
          para que seja efetuado o referido débito até sua exclusão do convênio, ou término do contrato, em favor da
          CONTRATANTE.
        </p>
      </li>
      <li>
        <p class="m-2">
          12. A comunicação do banco SANTANDER e BANCO DO BRASIL agência corrente do BENEFICIÁRIO, será competente
          comprovação de sua regularidade na manutenção do convênio de saúde junto à CONTRATADA.
        </p>
      </li>
      <li>
        <p class="m-2">13.O BENEFICIÁRIO fica ciente que:</p>
        <ul>
          <li>
            I. Terá seu atendimento suspenso caso atrase o pagamento da mensalidade por período superior ou igual a 60
            (sessenta) dias.
          </li>
          <li>
            II. Declara o BENEFICIÁRIO TITULAR ter conhecimento de que será excluído do presente contrato em caso de
            perda da elegibilidade e nos casos de inadimplemento, atrasando o pagamento da mensalidade por período igual
            ou superior a 60 (sessenta) dias consecutivos ou não, nos últimos doze meses de vigência, desde que seja
            cientificado até o quinquagésimo dia de inadimplência, oportunidade em que será concedido prazo de 10 (dez)
            dias para regularização do débito, sem prejuízo do direito de lhe ser requerida judicialmente a quitação do
            débito com suas consequências moratórias.
          </li>
          <li>
            III. No caso do cancelamento do plano contratado, haverá a exclusão do BENEFICIÁRIO TITULAR e dos
            BENEFICIÁRIOS DEPENDENTES, quando houver, sem prejuízo da cobrança dos valores em aberto com seus
            respectivos encargos.
          </li>
        </ul>
      </li>
      <li>
        <p class="m-2">
          14.O não cumprimento das obrigações do BENEFICIÁRIO, previstas neste instrumento e no Contrato Padrão, bem
          como a utilização indevida do cartão após o cancelamento solicitado ou por inadimplência, autoriza a adoção de
          medidas judiciais por parte da CONTRATANTE e da CONTRATADA, para a cobrança de eventuais prejuízos que vierem
          a ser apurados por parte da CONTRATANTE, inclusive proceder com a inscrição do BENEFICIÁRIO inadimplente nos
          órgãos de proteção ao crédito, a seu critério e conveniência.
        </p>
      </li>
      <li>
        <p class="m-2">
          15.O BENEFICIÁRIO e seus dependentes, comprometem-se a fazer uso normal e criterioso da carteira de
          atendimento fornecida pela CONTRATADA, sendo certo que a verificação de quaisquer abusos ou irregularidades
          praticadas com o dolo ou culpa pelo BENEFICIÁRIO ou dependentes, constituem justa causa para a exclusão do
          plano de saúde sem prejuízo de eventuais sanções de natureza disciplinar previstas no Estatuto Social do
          Sindicato, das medidas legais cabíveis destinadas ao ressarcimento dos danos causados à CONTRATADA ou
          CONTRATANTE.
        </p>
      </li>
      <li>
        <p class="m-2">
          16.Fica ainda, obrigado o BENEFICIÁRIO a promover a devolução de sua carteirinha, bem como a de seus
          dependentes, no caso de sua exclusão do plano de saúde por qualquer motivo.
        </p>
      </li>
      <li>
        <p class="m-2">
          18.O BENEFICIÁRIO outorga a UDEMO procuração para que a mesma possa representá-lo e a seus dependentes perante
          a Operadora de Saúde e a Agência Nacional de Saúde Suplementar – ANS, no cumprimento das cláusulas do contrato
          inclusive nos reajustes.
        </p>
      </li>
    </ul>
    <h3
      class="titulo text-justify bold-preto-700 mt-2"
      style="padding: 0.5rem; background: black; color: #fff; border-radius: 10px">
      Declaro ter lido e estar de acordo com os itens acima declaro ter recebido, antes da assinatura do presente
      contrato, o Manual de Orientação para Contratação do Plano de Saúde (MPS), cópia da Proposta de Adesão e da
      Declaração de Saúde. Declaro ainda, estar ciente de que o cartão de identificação do beneficiário será encaminhado
      posteriormente, após a confecção.
    </h3>
    <!-- <div class="doc-footer border mb-5" style="border-radius: 10px; padding: 0.5rem">
      <p>
        <b>Assinatura do beneficiário titular:</b>
      </p>
      <p>
        Assinatura via área logada pelo beneficiário {{ nomeTitular }} em {{ dataAssinaturaDocFinal }} às
        {{ horaAssinaturaDocFinal }}, comercialização através da corretora {{ nomeCorretora }} e vendedor
        {{ nomeVendedor }}, conforme Art. 7º da RN 413
      </p>
      <p>Data de preenchimento da proposta: {{ dataAssinaturaDocFinal }}</p>
    </div> -->
    <app-assinatura-documento
      [nomeTitular]="nomeTitular"
      [dataAssinatura]="dataAssinaturaDocFinal"
      [horaAssinatura]="horaAssinaturaDocFinal"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
  </div>
</section>

<section>
  <div class="rodape-sem-quebra nova-pagina documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

    <app-carta-orientacao-beneficiario
      [nomeTitular]="nomeTitular"
      [dataAssinaturaCartaOrientacaoDS]="dataAssinaturaCartaOrientacaoDS"
      [horaAssinaturaCartaOrientacaoDS]="horaAssinaturaCartaOrientacaoDS"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-carta-orientacao-beneficiario>
  </div>
</section>

<!-- informações Importantes -->
<section>
  <div class="documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
    <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
      Informações Importantes
    </h3>
    <ul>
      <li>
        <p class="m-2">
          1. No preenchimento desta declaração, o consumidor tem a opção de ser orientado, sem ônus financeiro, por um
          médico indicado pela Operadora; ou por um de sua confiança, neste caso as despesas com honorários serão de sua
          responsabilidade.
        </p>
      </li>
      <li>
        <p class="m-2">
          2. A Declaração de Saúde tem por objetivo registrar a existência de doenças e lesões preexistentes, como sendo
          aquelas que o consumidor tenha conhecimento no momento da assinatura do contrato, em relação a si próprio ou a
          qualquer de seus dependentes.
        </p>
      </li>
      <li>
        <p class="m-2">
          3.
          <b>No momento da adesão</b>
          , havendo declaração de doença ou lesão preexistente, podem ser oferecidas duas opções:
        </p>
        <ul class="ml-3 mr-3">
          <li>
            a.
            <b>Cobertura Parcial Temporária:</b>
            o consumidor não terá direito a cirurgias, procedimentos de alta complexidade, ou leitos de alta tecnologia
            relacionados à doença ou lesão declarada, por um período de 24 (vinte e quatro) meses.
          </li>
          <li *ngIf="!heMedSenior">
            b.
            <b>Agravo:</b>
            acréscimo no preço mensal do plano, pelo período de 24 (vinte e quatro) meses, para que o consumidor tenha
            direito à cobertura completa da doença ou lesão preexistente declarada, após os prazos de carências
            contratuais.
            <b>
              <u>
                Esta operadora de planos privados de assistência à saúde não trabalha com o oferecimento de Agravo
                (artigo 6º RN 162 de 2007).
              </u>
            </b>
          </li>
        </ul>
      </li>
      <li>
        <p class="m-2">
          4. A Declaração de Condições de Saúde deve ser preenchida de próprio punho pelo
          <b>BENEFICIÁRIO TITULAR</b>
          <span *ngIf="!heMedSenior">
            se maior de 18 anos, em nome próprio e de seus BENEFICIÁRIOS DEPENDENTES ou pelo responsável, se o
            BENEFICIÁRIO TITULAR for menor de 18 anos ou incapaz
          </span>
        </p>
      </li>
      <li>
        <p class="m-2">
          5. Toda resposta afirmativa deve ser esclarecida, informando a ocorrência (doença, lesão ou deficiência,
          tratamento ou cirurgia realizados ou a realizar e problema de saúde), a data da constatação da doença que o
          <b>BENEFICIÁRIO</b>
          se refere.
        </p>
      </li>
      <li>
        <p class="m-2">
          6. Nenhuma cobertura poderá ser negada ao consumidor para doenças ou lesões preexistentes não declaradas, até
          que a Operadora apresente as provas concretas junto à ANS de que o consumidor omitiu a doença ou lesão no
          preenchimento desta declaração. ATÉ DECISÃO DA ANS NÃO HAVERÁ SUSPENSÃO DO CONTRATO NEM DO ATENDIMENTO.
        </p>
      </li>
      <li>
        <p class="m-2">
          7.
          <b>
            A omissão de informação sobre a existência de doença ou lesão preexistente da qual o consumidor saiba ser
            portador no momento do preenchimento dessa declaração, desde que comprovada junto à ANS, pode acarretar a
            suspensão ou cancelamento do contrato. Nesse caso, o consumidor será responsável pelas despesas realizadas
            no tratamento da doença ou lesão omitida, a partir da data em que tiver recebido comunicado ou notificação
            da operadora alegando a existência de doença ou lesão preexistente não declarada.
          </b>
        </p>
      </li>
    </ul>
  </div>
</section>

<!-- INfo referente a medSenior inicio  -->

<ng-container *ngIf="heMedSenior">
  <app-documento-final-medsenior
    [dadosProposta]="dadosProstaCompletos"
    [operadoraVM]="operadoraVM"
    [entidadeProposta]="entidadeProposta"
    [codigoProposta]="codigoProposta"
    [dataVigencia]="vigenciaProposta"
    [dataAssinatura]="dataAssinaturaDadosBancarios"
    [nomeBeneficiario]="nomeTitular"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [nomeVendedor]="nomeVendedor"
    [horaAssinatura]="horaAssinaturaDadosBancarios"></app-documento-final-medsenior>
</ng-container>
<!-- ifnor referente a medSenior Fim -->

<!-- Perguntas  -->
<ng-container *ngIf="!heMedSenior">
  <section *ngIf="mostrarDS">
    <div class="documento-aditivo-container espacamento-mobile">
      <app-header-documento-final-proposta
        [entidadeProposta]="entidadeProposta"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="vigenciaProposta"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
      <p class="mb-1">
        Nome do beneficiário titular:
        <b>{{ nomeTitular }}</b>
      </p>
      <div class="card mt-1 mb-5">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered text-center">
              <thead>
                <tr>
                  <th class="bold-preto-400" style="text-align: left; color: black">
                    <b>(S) Sim (N) Não</b>
                    - Em caso de resposta afirmativa, descreva no quadro de especificações.
                  </th>
                  <th *ngIf="temRespostasTitular()">Tit.</th>
                  <th *ngFor="let dep of getDependentesComRespostas()">Dep. {{ dep.numero }}</th>
                </tr>
              </thead>
              <tbody>
                <!-- Perguntas -->
                <tr *ngFor="let pergunta of perguntasDeclaracaoSaude; let idx = index">
                  <td class="text-left">{{ idx + 1 }} - {{ pergunta.questionText }}</td>
                  <!-- Resposta do titular -->
                  <td *ngIf="temRespostasTitular()">
                    <ng-container *ngIf="idx + 1 === 27 || idx + 1 === 28; else normalResposta">
                      {{ getResposta(idx + 1, 0) }}
                    </ng-container>
                    <ng-template #normalResposta>
                      {{ getResposta(idx + 1, 0) }}
                    </ng-template>
                  </td>
                  <!-- Respostas dos dependentes -->
                  <td *ngFor="let dep of getDependentesComRespostas(); let depIdx = index">
                    <ng-container *ngIf="idx + 1 === 27 || idx + 1 === 28; else normalRespostaDep">
                      {{ getResposta(idx + 1, dep.index + 1) }}
                    </ng-container>
                    <ng-template #normalRespostaDep>
                      {{ getResposta(idx + 1, dep.index + 1) }}
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Termo  -->
  <section *ngIf="mostrarDS">
    <div class="documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
      <app-header-documento-final-proposta
        [entidadeProposta]="entidadeProposta"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="vigenciaProposta"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
      <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
        Opção para Doenças e/ou Lesões Pré-existentes
      </h3>
      <div class="col-md-12 col-sm-12 mt-1">
        <p>
          Havendo declaração de doenças ou lesões preexistentes e tendo sido orientado, estou ciente da Cobertura
          Parcial Temporária (CPT) – período ininterrupto de 24 meses em que estará suspensa a cobertura de
          Procedimentos de Alta Complexidade (PAC), leitos de alta tecnologia e procedimentos cirúrgicos relacionados às
          doenças e lesões pré-existentes.
        </p>
      </div>
      <p class="titulo bold-preto-700 mt-1 mb-1 p-1 border" style="background: #ccc; margin-bottom: 0px !important">
        Caso algum dos Beneficiários apresente resposta(s) afirmativa(s), favor especificar abaixo, informando datas,
        tratamentos, situação atual e tudo que for importante para avaliação médica.
      </p>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Beneficiário Nº</th>
              <th>Item</th>
              <th>Data Evento</th>
              <th>Especificações</th>
              <th>USO OPERADORA Código CID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let respostas of respostasPositivasDS; let i = index">
              <td>{{ respostas.tipoBeneficiario }}</td>
              <td>{{ respostas.item }}</td>
              <td>{{ respostas.dataEvento }}</td>
              <td>{{ respostas.especificacoes }}</td>
              <td>{{ respostas.cid }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12 col-sm-12 mt-1" *ngFor="let grupo of getAgrupamentoBeneficiarioPorDS()">
        <ng-container *ngIf="grupo.valor">
          <p *ngIf="grupo.nomes.length === 1">
            Eu,
            <span class="bold-preto-700" style="color: black">{{ grupo.nomes[0] }}</span>
            , declaro ainda que:
          </p>

          <p *ngIf="grupo.nomes.length > 1">
            Nós,
            <span class="bold-preto-700" style="color: black">{{ grupo.nomes.join(', ') }}</span>
            , declaramos ainda que:
          </p>
          <div class="card-content col-md-12 col-sm-12 mt-1">
            <div class="form-group mb-1 col-sm-12 col-md-12 declaracao-options">
              <div class="row option-row">
                <label class="checkbox-container">
                  <input type="radio" class="hidden-checkbox" [checked]="grupo.valor === '1'" disabled />
                  <span class="checkmark"></span>
                  <span class="option-text">
                    Fui orientado por médico cooperado à UNIMED FESP no preenchimento da declaração de saúde;
                  </span>
                </label>
              </div>
              <div class="row option-row">
                <label class="checkbox-container">
                  <input type="radio" class="hidden-checkbox" [checked]="grupo.valor === '2'" disabled />
                  <span class="checkmark"></span>
                  <span class="option-text">
                    Fui orientado por um médico particular, no preenchimento da declaração de saúde, arcando com o ônus
                    da consulta;
                  </span>
                </label>
              </div>
              <div class="row option-row">
                <label class="checkbox-container">
                  <input type="radio" class="hidden-checkbox" [checked]="grupo.valor === '3'" disabled />
                  <span class="checkmark"></span>
                  <span class="option-text">
                    Entendi o conteúdo de todas as perguntas da declaração de saúde e dispensei a orientação médica para
                    respondê-las, assumindo total responsabilidade pelas informações por mim prestadas.
                  </span>
                </label>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <!-- <div class="doc-footer border mb-5" style="border-radius: 10px; padding: 0.5rem">
      <p>
        <b>Assinatura do beneficiário titular:</b>
      </p>
      <p>
        Assinatura via área logada pelo beneficiário {{ nomeTitular }} em {{ dataAssinaturaDS }} às
        {{ horaAssinaturaDS }}, comercialização através da corretora {{ nomeCorretora }} e vendedor {{ nomeVendedor }},
        conforme Art. 7º da RN 413
      </p>
      <p>Data de preenchimento da proposta: {{ dataAssinaturaDS }}</p>
    </div> -->
      <app-assinatura-documento
        [nomeTitular]="nomeTitular"
        [dataAssinatura]="dataAssinaturaDS"
        [horaAssinatura]="horaAssinaturaDS"
        [nomeCorretora]="nomeCorretora"
        [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
    </div>
  </section>
</ng-container>
<!-- Informações  -->
<section class="nova-pagina">
  <div class="documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
    <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
      Informo, para diversos fins e efeitos, que:
    </h3>
    <ul>
      <li>
        <p class="m-2">
          * Autorizo a CONTRATADA solicitar, a qualquer tempo, á médicos, hospitais, clínicas, laboratórios, exames,
          prontuários e informações necessárias para a elucidação de qualquer assunto que se relacione com o presente
          contrato. Isentando-os desde já, de qualquer responsabilidade que implique ofensa ao sigilo profissional.
        </p>
      </li>
      <li>
        <p class="m-2">
          * As informações de saúde relativas à minha pessoa e a meus dependentes são verdadeiras e completas e foram
          espontaneamente fornecidas, estando ciente de que a omissão de fatos e/ou o preenchimento incorreto da
          Declaração de Saúde poderá ser considerada como conduta inaceitável, implicando a minha pessoa, a
          responsabilidade pelo pagamento de despesas efetuadas com a assistência médica e hospitalar com obstetrícia e
          também o cancelamento total da minha presente adesão, a qualquer tempo.
        </p>
      </li>
      <li>
        <p class="m-2">
          *
          <b>
            Preenchi a Declaração de Saúde de todos os dependentes/agregados neste ato, mas sendo meus
            dependentes/agregados maiores que 15 (quinze) anos, comprometo-me a investigar as informações com os mesmos
            e, havendo necessidade de alteração, apresentarei as mesmas por escrito no prazo de 7 (sete) dias contatos a
            partir da data de assinatura desta, sob pena de não atendimento ou exclusão do dependente/agregado com
            Declaração de Saúde inadequada e até mesmo, rescisão, caso apurada a omissão.
          </b>
        </p>
      </li>
      <li>
        <p class="m-2">
          * Tenho o conhecimento de que as informações ora prestadas deverão ser completas e exatas, sob pena de
          inviabilizar a aceitação da presente proposta.
        </p>
      </li>
    </ul>
    <!-- <div class="doc-footer border mb-5" style="border-radius: 10px; padding: 0.5rem">
      <p>
        <b>Assinatura do beneficiário titular:</b>
      </p>
      <p>
        Assinatura via área logada pelo beneficiário {{ nomeTitular }} em {{ dataAssinaturaDocFinal }} às
        {{ horaAssinaturaDocFinal }}, comercialização através da corretora {{ nomeCorretora }} e vendedor
        {{ nomeVendedor }}, conforme Art. 7º da RN 413
      </p>
      <p>Data de preenchimento da proposta: {{ dataAssinaturaDocFinal }}</p>
    </div> -->
    <app-assinatura-documento
      [nomeTitular]="nomeTitular"
      [dataAssinatura]="dataAssinaturaDocFinal"
      [horaAssinatura]="horaAssinaturaDocFinal"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
  </div>
</section>
<!-- Orientação da Portabilidade -->
<section *ngIf="mostrarOrientacaoPortabilidade">
  <app-orientacao-portabilidade-sumula-proposta
    [razaoSocialEntidade]="razaoSocialEntidade"
    [entidadeProposta]="entidadeProposta"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [mostrarOrientacaoPortabilidade]="mostrarOrientacaoPortabilidade"></app-orientacao-portabilidade-sumula-proposta>
  <!-- Assinatura -->
  <!-- <div class="doc-footer border m-3" style="border-radius: 10px; padding: 0.5rem">
    <p>
      <b>Assinatura do beneficiário:</b>
    </p>
    <p>
      Assinatura via área logada pelo beneficiário
      {{ nomeTitular }} em {{ dataAssinaturaOrientacaoPortabilidade }} às {{ horaAssinaturaOrientacaoPortabilidade }},
      comercialização através da corretora {{ nomeCorretora }} e vendedor {{ nomeVendedor }}, conforme Art. 7º da RN 413
    </p>
    <p>
      Data de preenchimento da proposta:
      {{ dataAssinaturaOrientacaoPortabilidade }}
    </p>
  </div> -->

  <app-assinatura-documento
    [nomeTitular]="nomeTitular"
    [dataAssinatura]="dataAssinaturaOrientacaoPortabilidade"
    [horaAssinatura]="horaAssinaturaOrientacaoPortabilidade"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
</section>
<!-- Orientação da Súmula 21 -->
<section *ngIf="mostrarOrientacaoSumula">
  <app-orientacao-portabilidade-sumula-proposta
    [razaoSocialEntidade]="razaoSocialEntidade"
    [entidadeProposta]="entidadeProposta"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [mostrarOrientacaoSumula]="mostrarOrientacaoSumula"></app-orientacao-portabilidade-sumula-proposta>
  <!-- Assinatura -->
  <!-- <div class="doc-footer border m-3" style="border-radius: 10px; padding: 0.5rem">
    <p>
      <b>Assinatura do beneficiário:</b>
    </p>
    <p>
      Assinatura via área logada pelo beneficiário
      {{ nomeTitular }} em {{ dataAssinaturaOrientacaoSumula }} às {{ horaAssinaturaOrientacaoSumula }}, comercialização
      através da corretora {{ nomeCorretora }} e vendedor {{ nomeVendedor }}, conforme Art. 7º da RN 413
    </p>
    <p>
      Data de preenchimento da proposta:
      {{ dataAssinaturaOrientacaoSumula }}
    </p>
  </div> -->

  <app-assinatura-documento
    [nomeTitular]="nomeTitular"
    [dataAssinatura]="dataAssinaturaOrientacaoSumula"
    [horaAssinatura]="horaAssinaturaOrientacaoSumula"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
</section>
<!-- Aditivo Súmula 21 e Portabilidade -->
<section *ngFor="let beneficiario of getBeneficiariosComSumula21EPortabolidade()">
  <app-documento-aditivo
    [nomeTitular]="beneficiario.name"
    [codigoProposta]="codigoProposta"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [tipoProposta]="beneficiario.proposalType"></app-documento-aditivo>
  <div class="doc-footer border m-3" style="border-radius: 10px; padding: 0.5rem">
    <app-assinatura-documento
      [ehTitular]="false"
      [nomeTitular]="nomeTitular"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"
      [dataAssinatura]="
        getDataHoraAssinatura(
          beneficiario,
          beneficiario.proposalType === TipoPropostaEnum.SUMULA ? 'SUMULA' : 'PORTABILIDADE'
        ).data
      "
      [horaAssinatura]="
        getDataHoraAssinatura(
          beneficiario,
          beneficiario.proposalType === TipoPropostaEnum.SUMULA ? 'SUMULA' : 'PORTABILIDADE'
        ).hora
      "></app-assinatura-documento>
  </div>
</section>
<!-- Redução de Carencias -->
<section>
  <app-reducao-carencia-proposta
    [dadosOperadoraDM]="dadosOperadoraDM"
    [dataCriacaoProposta]="dataCriacaoProposta"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [mostrarQuadroDoisReducaoCarencia]="mostrarQuadroDoisReducaoCarencia"
    [listaBeneficiariosCarencias]="listaBeneficiariosCarencias"
    [heMedSenior]="heMedSenior"
    [nomeTitular]="nomeTitular"></app-reducao-carencia-proposta>
  <div class="texto-rodade-assinatura">
    <app-assinatura-documento
      [nomeTitular]="nomeTitular"
      [dataAssinatura]="dataAssinaturaDocFinal"
      [horaAssinatura]="horaAssinaturaDocFinal"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
  </div>
</section>
<!-- Carta Recusa/Aceite Portabilidade -->

<!-- Email Declinio Proposta -->
<section *ngIf="statusProposta">
  <app-emails-declinio-proposta
    [tipoPropostaDeclinada]="tipoDeclinio"
    [dataDeclinio]="dataDeclinio"
    [horaDeclinio]="horaDeclinio"
    [motivoDeclinio]="motivoDeclinio"
    [nomeTitular]="nomeTitular"
    [codigoProposta]="codigoProposta"
    [motivoDeclinio]="motivoDeclinio"></app-emails-declinio-proposta>
</section>
<!-- formulario de inscricao de entidade -->
<ng-container
  *ngIf="
    (entidadeProposta == 'ADSERVIP' || entidadeProposta == 'ABJE') && !this.dadosOperadoraCabecalho.ehInclusaoDependente
  ">
  <section *ngIf="existeFormularioEntidade && !dadosProstaCompletos?.externalRegistrationLink">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
    <app-formulario-inscricao-entidade-adservip
      *ngIf="this.entidadeProposta === 'ADSERVIP'"
      [formEntidadeSomenteLeitura]="true"
      [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"></app-formulario-inscricao-entidade-adservip>
    <app-formulario-inscricao-entidade-abje
      *ngIf="entidadeProposta === 'ABJE'"
      [formEntidadeSomenteLeitura]="true"
      [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"
      [logoEntidade]="null"
      [nomeEntidade]="entidadeProposta"></app-formulario-inscricao-entidade-abje>

    <app-assinatura-documento
      [nomeTitular]="nomeTitular"
      [dataAssinatura]="dataAssinaturaDadosBancarios"
      [horaAssinatura]="horaAssinaturaDadosBancarios"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
  </section>
</ng-container>
<!-- Documento de Reajuste UDEMO (mês de outubro) -->
<ng-container *ngIf="ehReajusteUdemo(dataCriacaoProposta)">
  <app-documento-reajuste-udemo
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [dadosOperadoraDM]="dadosOperadoraDM"
    [nomeTitular]="nomeTitular"
    [cpfTitular]="cpfTitular"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-documento-reajuste-udemo>
  <app-assinatura-documento
    [nomeTitular]="nomeTitular"
    [dataAssinatura]="dataAssinaturaDadosBancarios"
    [horaAssinatura]="horaAssinaturaDadosBancarios"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
</ng-container>
<!-- Documentos Beneficiário -->
<section>
  <div class="nova-pagina">
    <app-lista-documentos-proposta
      [dadosOperadoraDM]="dadosOperadoraDM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [entidadeProposta]="entidadeProposta"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [beneficiariosComDocumentos]="beneficiariosComDocumentos"></app-lista-documentos-proposta>
  </div>
</section>
